import { NgModule } from '@angular/core';
import { TickCrossComponent } from './components/tick-cross/tick-cross.component';
import { LoadingComponent } from './components/loading/loading.component';
import { CommonModule } from '@angular/common';
import { ValidationSummaryComponent } from './components/validation-summary/validation-summary.component';
import { DirectivesModule } from '../directives/directives.module';

@NgModule({
  imports: [
    DirectivesModule,
    CommonModule,
  ],
  declarations: [
    TickCrossComponent,
    LoadingComponent,
    ValidationSummaryComponent
  ],
  providers: [],
  exports: [
    TickCrossComponent,
    LoadingComponent,
    ValidationSummaryComponent
  ]
})
export class FoundationModule {
}



// WEBPACK FOOTER //
// ./src/_foundation/foundation.module.ts